<template>
    <activation-brief-payments-provider
        v-slot="{
            brief,
            contact,
            step,
            currentStep,
            isPreview,
            completeBrief,
            patchStep,
            goNextStep,
            goPreviousStep,
            isLoading,
            isCompletingBrief,
            errors,
            errorMessage,
            affiliateLinks,
            discountCodes
        }"
        style="height: 100%">
        <activation-brief-payments-view
            :brief="brief"
            :step="step"
            :is-loading="isLoading"
            :is-completing-brief="isCompletingBrief"
            :errors="errors"
            :error-message="errorMessage"
            :affiliate-links="affiliateLinks"
            :discount-codes="discountCodes"
            @go-next-step="goNextStep"
            @go-previous-step="goPreviousStep"
            @patch-step="patchStep"
        />
    </activation-brief-payments-provider>
</template>

<script>
    import ActivationBriefPaymentsProvider from '../providers/activation-brief-steps/ActivationBriefPaymentsProvider';
    import ActivationBriefPaymentsView from '../data-views/activation-briefs/ActivationBriefPaymentsView';
    export default {
        name:       'ActivationBriefPaymentsRouterView',
        components: {ActivationBriefPaymentsView, ActivationBriefPaymentsProvider},
    };
</script>

<style scoped>

</style>
